import { render, staticRenderFns } from "./gsr_stxm_report.vue?vue&type=template&id=a4bdcaa2&scoped=true"
import script from "./gsr_stxm_report.vue?vue&type=script&lang=js"
export * from "./gsr_stxm_report.vue?vue&type=script&lang=js"
import style0 from "./gsr_stxm_report.vue?vue&type=style&index=0&id=a4bdcaa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bdcaa2",
  null
  
)

export default component.exports